import {
  Component,
  OnInit,
  ViewEncapsulation,
  EventEmitter,
} from "@angular/core";
import { TimePickerModalService } from "../time-picker-shared/providers/time-picker-modal.service";
import { TimePickerModalToolsService } from "../time-picker-shared/providers/time-picker-modal-tools.service";
import { of } from "rxjs";
import { delay, tap } from "rxjs/operators";

@Component({
  standalone: false,
  selector: "app-time-picker-modal",
  templateUrl: "./time-picker-modal.component.html",
  styleUrls: ["./time-picker-modal.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class TimePickerModalComponent implements OnInit {
  timeFormat = "hh:mm";
  format = "hh:mm tt";
  /**
   * Animation  of time picker modal component
   */
  animation = true;
  /**
   * Animation hour holder of time picker modal component
   */
  animationHourHolder = false;
  /**
   * Hidden  of time picker modal component
   */
  hidden = true;
  /**
   * Closed  of time picker modal component
   */
  closed: EventEmitter<any> = new EventEmitter();
  /**
   * Hour active of time picker component
   */
  hourSectionActive = true;
  /**
   * Minute active of time picker component
   */
  minuteSectionActive = false;
  /**
   * Am active of time picker component
   */
  amActive = false;
  /**
   * Pm active of time picker component
   */
  pmActive = false;
  /**
   * Select hour of time picker component
   */
  selectHour: number = 0;
  /**
   * Select minute of time picker component
   */
  selectMinute: number = 0;
  /**
   * Creates an instance of time picker modal component.
   * @param timePickerModalService TimePickerModalService
   */
  constructor(private toolsService: TimePickerModalToolsService) {}
  /**
   * on init
   */
  ngOnInit() {
    const date = new Date();
    this.selectHour = this.toolsService.getHour(date.getHours(), true);
    this.selectMinute = date.getMinutes();
    const ampm = this.toolsService.getT(date.getHours());
    this.amActive = ampm === "AM" || false;
    this.pmActive = ampm === "PM" || false;
    of([])
      .pipe(delay(10))
      .subscribe(() => {
        this.animation = false;
      });
  }
  /**
   * Determines whether click time active on
   */
  onClickTimeActive(): void {
    this.hourSectionActive = !this.hourSectionActive;
    this.minuteSectionActive = !this.minuteSectionActive;
    this.animationHourHolder = true;
    of([])
      .pipe(delay(100))
      .subscribe(() => {
        this.animationHourHolder = false;
      });
  }
  /**
   * Determines whether click am pm active on
   */
  onClickAmPmActive(): void {
    this.amActive = !this.amActive;
    this.pmActive = !this.pmActive;
  }
  /**
   * Determines whether click hour on
   * @param hour number
   */
  onClickHour(hour: number): void {
    this.selectHour = hour;
    this.onClickTimeActive();
  }
  /**
   * Determines whether click minute on
   * @param minute number
   */
  onClickMinute(minute: number): void {
    this.selectMinute = minute;
  }
  /**
   * Determines whether click accept on
   */
  onClickAccept() {
    of([])
      .pipe(delay(300))
      .subscribe(() => {
        this.hidden = true;
        this.animation = false;
        of([])
          .pipe(delay(300))
          .subscribe(() => {
            const ampm = this.amActive ? "AM" : "PM";
            this.closed.emit({
              time: this.toolsService.format(
                this.selectHour,
                this.selectMinute,
                this.timeFormat,
                ampm
              ),
              value: this.toolsService.format(
                this.selectHour,
                this.selectMinute,
                this.format,
                ampm
              ),
            });
          });
      });
  }

  /**
   * Determines whether click closed on
   */
  onClickClosed(): void {
    this.closed.emit();
  }
  /**
   * Determines whether click outside on
   * @param event any
   */
  onClickOutside(event: any): void {
    const clickedInside = document
      .querySelector(".time-picker__content")
      .contains(event.target);
    if (!clickedInside) {
      this.animation = true;
      of([])
        .pipe(delay(300))
        .subscribe(() => {
          this.hidden = true;
          this.animation = false;
          of([])
            .pipe(delay(300))
            .subscribe(() => this.closed.emit());
        });
    }
  }
  /**
   * Gets class hours rotate
   * @param hour number
   * @returns any
   */
  getClassHoursRotate(index: number): any {
    return this.toolsService.getClassForHour(this.selectHour, index);
  }
  /**
   * Gets class minutes rotate
   * @param minute number
   * @returns any
   */
  getClassMinutesRotate(index: number): any {
    return this.toolsService.getClassForMinutes(this.selectMinute, index);
  }
  /**
   * Gets class hour holder
   * @returns any
   */
  getClassHourHolder(): any {
    const classNames: any = {};
    if (!this.hourSectionActive && this.minuteSectionActive) {
      classNames["hidden"] = true;
      classNames["animate"] = this.animationHourHolder;
    }
    return classNames;
  }
  /**
   * Gets class minute holder
   * @returns any
   */
  getClassMinuteHolder(): any {
    const classNames: any = {};
    if (this.hourSectionActive && !this.minuteSectionActive) {
      classNames["hidden"] = true;
      classNames["animate"] = this.animationHourHolder;
    }
    return classNames;
  }
}
